import { useContext } from "react";
import { AuthContext } from 'shared/context/auth-context';
import AuthenticatedApp from "components/AuthenticatedApp/AuthenticatedApp";
import { Redirect, BrowserRouter as Router } from "react-router-dom";
import LoginSubmission from "containers/Login/LoginSubmission";
import './App.css';

export default function App() {
  const { roleUser } = useContext(AuthContext);

  return (
    <>
      {roleUser ? <AuthenticatedApp /> : <Router><Redirect to="/" /><LoginSubmission /></Router>}
    </>
  );
}

